import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId"];
import React from 'react';
import LoadingSkeleton from '../../../common/loading-skeleton';
import Block from '../../block';
export var RelatedUrlsBlockResolvingView = function RelatedUrlsBlockResolvingView(_ref) {
  var testId = _ref.testId,
    blockProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
    testId: testId
  }), /*#__PURE__*/React.createElement(LoadingSkeleton, {
    height: 1.55,
    width: 22
  }));
};